import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { JwtHelperService } from '@auth0/angular-jwt';
import { UsersService } from '../users/users.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@angular/common/http";
import * as i3 from "../users/users.service";
const helper = new JwtHelperService();
export class AuthService {
    constructor(router, http, userService) {
        this.router = router;
        this.http = http;
        this.userService = userService;
        this.userObs = new Subject();
    }
    resetPassword(email, recaptchaKey) {
        return this.http.post(`${environment.api}/password/reset`, {
            email: email,
            recaptchaKey: recaptchaKey
        });
    }
    lorealLogin() {
        return this.http.post(`${environment.api}/panel/azure/redirect-uri`, {
            redirectUri: `${location.origin}/ssologin`
        });
    }
    lorealLoginGetToken(code) {
        return this.http.post(`${environment.api}/panel/azure/check-credentials`, {
            code,
            redirectUri: `${location.origin}/ssologin`
        });
    }
    // login(username: string, password: string): Observable<any> {
    //   return this.http.post(`${environment.api}/login`, {
    //     username: username,
    //     password: password
    //   })
    //   .pipe(
    //     map((data: any) => {
    //       if (data && data.token) {
    //         sessionStorage.setItem('userToken', JSON.stringify(data));
    //       }
    //     })
    //   );
    // }
    // sendCode(username: string, code: string) {
    //   return this.http
    //     .post(`${environment.api}/login/obtain-token`, {
    //       username: username,
    //       code: code
    //     })
    //     .pipe(
    //       map((data: any) => {
    //         if (data && data.token) {
    //           sessionStorage.setItem('userToken', JSON.stringify(data));
    //         }
    //       })
    //     );
    // }
    logout() {
        this.removeToken();
        setTimeout(() => {
            this.userService.resetMe();
        });
    }
    removeToken() {
        sessionStorage.removeItem('userToken');
        this.router.navigate(['/auth']);
    }
    getUser() {
        return this.userObs.asObservable();
    }
    isAuthenticated() {
        const data = sessionStorage.getItem('userToken');
        if (data && JSON.parse(data).token) {
            const decodedToken = helper.decodeToken(JSON.parse(data).token);
            const expirationDate = helper.getTokenExpirationDate(JSON.parse(data).token);
            const isExpired = helper.isTokenExpired(JSON.parse(data).token);
            if (!isExpired) {
                return true;
            }
        }
        return false;
    }
}
AuthService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthService_Factory() { return new AuthService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.HttpClient), i0.ɵɵinject(i3.UsersService)); }, token: AuthService, providedIn: "root" });
